import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recent-activity-section',
  templateUrl: './recent-activity-section.component.html',
  styleUrls: ['./recent-activity-section.component.scss']
})
export class RecentActivitySectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
